// extracted by mini-css-extract-plugin
export default {"container":"GameStart_container__xnpmA","gameScreen":"GameStart_gameScreen__gGCUW"};